// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5124 ? "shimport" : chunkId) + ".legacy." + {"5094":"ee84d365fed34d864d77","5124":"711ed2d7098e6a0079d7"}[chunkId] + ".js";
};